import { render, staticRenderFns } from "./index.vue?vue&type=template&id=959b1b64&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=959b1b64&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959b1b64",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('959b1b64')) {
      api.createRecord('959b1b64', component.options)
    } else {
      api.reload('959b1b64', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=959b1b64&scoped=true", function () {
      api.rerender('959b1b64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SkinPreview/index.vue"
export default component.exports